import { TAB_UPDATE_SELECTION } from 'actions/tabs';

export const tabReducerInitialState = {
  selected: null,
};

const tabReducer = (state = tabReducerInitialState, action) => {
  switch (action.type) {
    case TAB_UPDATE_SELECTION: {
      if (state.selected !== action.payload.selected) {
      }
      return { ...state, selected: action.payload.selected };
    }
    default:
      return state;
  }
};

export default tabReducer;
